module.exports = __webpack_public_path__ + "static/media/toolbox_banner_small.532ab6d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/toolbox_banner_small.png
// module id = 12
// module chunks = 0